// user-access-form.jsx
import { Button, Alert } from "antd";
import ProjectAccessTable from "./project-access-table";
import ProjectAccessInline from "./project-access-inline";
import { AddProjectModal } from "../../projects/add-project-modal";

const UserAccessForm = ({
  scope = "organization",          // "organization" | "project"
  orgRole,
  sitesFor,                        // (projectId) => { sitesEnabled, options }
  projectRows,
  updateRow,
  roles,                           // the roles the signed-in user may give
  projectRoleDropdownKey,
  setProjectRoleDropdownKey,
  getProjectTitle,
  projectModalOpen,
  setProjectModalOpen,
  selectedProjectIds,
  onSelectProject,
  project,
  isEdit = true,
  canEdit = true,
  removeProjectRow,
  readOnly = false,
}) => {
  const handleOpenProjectModal = () => setProjectModalOpen(true);
  const handleCloseProjectModal = () => setProjectModalOpen(false);

  if (scope === "project") {
    // The current project's row, not whichever project the user joined first.
    const row =
      projectRows.find((r) => r.projectId === project?.id) || projectRows[0];
    return (
      <ProjectAccessInline
        row={row}
        sitesFor={sitesFor}
        roles={roles}
        projectRoleDropdownKey={projectRoleDropdownKey}
        setProjectRoleDropdownKey={setProjectRoleDropdownKey}
        updateRow={updateRow}
        isEdit={isEdit}
        canEdit={canEdit}
        removeProjectRow={removeProjectRow}
        readOnly={readOnly}
      />
    );
  }

  // === ORGANIZATION LEVEL ===
  return (
    <div className="invite-user__projects">
      <p className="invite-user__section-title">Projects</p>

      {orgRole !== "user" ? (
        <Alert
          className="invite-user__projects-alert"
          title="Organization admin has access to all projects"
        />
      ) : (
        <>
          <div className="invite-user__projects-box">
            {projectRows.length === 0 && (
              <div className="invite-user__projects-empty">
                No projects selected yet
              </div>
            )}

            <ProjectAccessTable
              projectRows={projectRows}
              sitesFor={sitesFor}
              roles={roles}
              projectRoleDropdownKey={projectRoleDropdownKey}
              setProjectRoleDropdownKey={setProjectRoleDropdownKey}
              updateRow={updateRow}
              getProjectTitle={getProjectTitle}
              removeProjectRow={removeProjectRow}
              readOnly={readOnly}
            />
          </div>

          <Button
            type="dashed"
            className="invite-user__projects-add-btn"
            onClick={handleOpenProjectModal}
            disabled={readOnly}
          >
            Add project
          </Button>

          <AddProjectModal
            open={projectModalOpen}
            onClose={handleCloseProjectModal}
            selectedProjectIds={selectedProjectIds}
            onSelect={onSelectProject}
          />
        </>
      )}
    </div>
  );
};

export default UserAccessForm;